import React, { useEffect, useState } from 'react'
import { Grid, Button } from '@material-ui/core/'
import { IconSmileWow, IconSmileHappy, IconSmileNormal, IconSmileSad, IconSmileTerrible } from '../../../../../assetss/img/smile'
import c from 'classnames'
import './index.scss'

const ButtonSlideMobile = ({
  title,
  type,
  marginTop,
  value,
  step,
  onChangeValue,
  setValueSlide,
  activeSlide,
  feedback,
  path,
  isOpen,
  dataStatistick,
  setReactionId,
  idPodcast,
}) => {
  const [active, setActive] = useState(false)

  const goTo = () => {
    const win = window.open(`/reaction/${path}/${idPodcast}`, '_blank')
    win.focus()
  }

  const formatPercents = num => {
    if (+dataStatistick?.total === 0 || +dataStatistick?.detailed?.[num] === 0) return '0%'
    return ((+dataStatistick?.detailed?.[num] / +dataStatistick?.total) * 100).toFixed() + '%'
  }

  const Icon = () => {
    switch (type) {
    case 'wow':
      return <IconSmileWow color='#EED919' />

    case 'happy':
      return <IconSmileHappy color='#EED919' />

    case 'normal':
      return <IconSmileNormal color='#EED919' />

    case 'sad':
      return <IconSmileSad color='#EED919' />

    case 'terrible':
      return <IconSmileTerrible color='#EED919' />

    default:
      return <IconSmileWow color='#EED919' />
    }
  }

  useEffect(() => {
    if (+value >= +step - 1 && +value <= +step + 1) {
      setValueSlide(step)
      setActive(true)
    } else {
      setActive(false)
    }
  }, [value, step])

  useEffect(() => {
    if (active) {
      setReactionId(feedback)
    }
  }, [active])

  useEffect(() => {
    if (!isOpen) {
      setTimeout(() => {
        setActive(false)
      }, 1000)
    }
  }, [isOpen])

  return (
    <Grid className={c('wrapperBtnSlideMobile', activeSlide && 'wrapperBtnSlideMobileActive')} style={{ marginTop }}>
      <Grid className={c('markSlide', active && 'newMarkSlide', activeSlide && 'markSlideDisabled')} />

      <Button
        disabled={!active && activeSlide}
        onClick={() => onChangeValue(+step)}
        className={c('buttonSmileMobile', active && 'buttonSmileActiveMobile', activeSlide && active && 'buttonSmileSelectMobile', activeSlide && !active && 'buttonSmileDisabledMobile')}
        startIcon={Icon()}
        variant='outlined'
        color='primary'
      >
        {activeSlide ? `${formatPercents(feedback)} responses` : `${title}`}
      </Button>

      <Button
        onClick={goTo}
        className={c('buttonSeStoryMobile', activeSlide && 'buttonSeStoryActive', activeSlide && active && 'buttonSeStorySelect')}
        color='primary'
      >
        Stories
      </Button>
    </Grid>
  )
}

export default ButtonSlideMobile
